import * as React from "react";
import { Marker } from "react-simple-maps";
import FmdGoodIcon from "@mui/icons-material/FmdGood";

import { Pin, Pins } from "./types";

import theme from "../../../../../components/styles/theme/theme";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../store/store";

type Props = {
  data: Pins;
};

const renderMarkers = (data: Pins, selectedCountryName: string) => {
  let value = selectedCountryName === "Mexico" ? 3 : 5;
  return data.features.map((pin: Pin) => {
    const { properties } = pin;
    const { id, name } = properties;

    return (
      <Marker
        key={id}
        coordinates={[pin.geometry.coordinates[0], pin.geometry.coordinates[1]]}
        data-tooltip-content={
          name || "We have no found information about that location"
        }
        data-tooltip-id="my-tooltip"
        data-tooltip-offset={10}
        style={{
          default: {
            outline: "none",
            fill: theme.palette.common.black,
            stroke: theme.palette.common.white,
            strokeWidth: 0.3,
          },
          hover: {
            outline: "none",
            fill: theme.palette.common.black,
            stroke: theme.palette.common.white,
            strokeWidth: 0.6,
          },
          pressed: {
            outline: "none",
            fill: theme.palette.common.black,
            stroke: theme.palette.common.white,
            strokeWidth: 0.6,
          },
        }}
      >
        <g transform={`translate(-${value / 2}, -${value / 2})`}>
          <FmdGoodIcon width={value} height={value} />
        </g>
      </Marker>
    );
  });
};

export const Markers: React.FC<Props> = ({ data }) => {
  const selectedCountryName = useSelector(
    (state: RootState) => state.map.selectedCountry?.country_name || ""
  );
  return <>{data && renderMarkers(data, selectedCountryName)}</>;
};

export default Markers;
